import React, { useEffect } from 'react';
import { autorun } from 'mobx';
import { observer } from 'mobx-react-lite';
import { useHistory } from 'react-router-dom';
import cn from 'classnames';
import { Box, Table, TableHead, TableRow, TableCell, TableBody, Grid } from '@material-ui/core';
import { Amount, Page, AppBar, ScreenLoader, EmptyState } from 'components';
import { anketsStore, fsspStore } from 'stores';
import { ru } from 'locale';
import { NoData as NoDataBg } from 'resources/images';
import useStyles from './FsspScreen.styles';

const FsspScreen = observer(() => {
  const classes = useStyles();
  const history = useHistory();
  const { fetchState, items } = fsspStore;
  const hasItems = items.length !== 0;

  useEffect(
    () =>
      autorun(() => {
        fsspStore.getExecutiveProceedings(anketsStore.anketId);
      }),
    [],
  );

  const handleBackClick = () => {
    history.goBack();
  };

  const renderItems = () => {
    if (!hasItems) {
      return (
        <EmptyState
          image={{ source: NoDataBg, alt: ru.listOfExecutiveProceeding }}
          title={ru.emptyList(ru.listOfExecutiveProceeding)}
        />
      );
    }

    return (
      <Box mt={2}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>{ru.name}</TableCell>
              <TableCell>{ru.count}</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {items.map((item, idx) => {
              return (
                /* eslint-disable-next-line react/no-array-index-key */
                <TableRow key={idx}>
                  <TableCell>{item.name}</TableCell>
                  <TableCell align="right">
                    {idx % 2 === 0 ? (
                      item.value
                    ) : (
                      <Amount
                        color="textPrimary"
                        amount={{ value: item.value, currency: { code: 'RUR', minority: 0 } }}
                      />
                    )}
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </Box>
    );
  };

  return (
    <Page fullScreen style={{ minHeight: '100rvh' }}>
      <Grid container direction="column">
        <AppBar title={ru.executiveProceedings} onNavButtonClick={handleBackClick} />
        {fetchState === 'pending' && <ScreenLoader />}

        <Grid
          container
          item
          direction="column"
          justify={hasItems ? 'flex-start' : 'center'}
          className={cn({
            [classes.content]: !hasItems,
          })}
        >
          {fetchState === 'fulfilled' && renderItems()}
        </Grid>
      </Grid>
    </Page>
  );
});

export default FsspScreen;
